import React, { useState, useEffect } from "react";

import RTMService from "../../services/rtm";
import Events from "../../services/events";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import colors from "../../styles/colors";
import { colorsV2 } from "../../styles/colors";
import Dialog from "material-ui/Dialog";
import DatePicker from "material-ui/DatePicker";
import CalIcon from "material-ui/svg-icons/action/date-range";
import CancelIcon from "material-ui/svg-icons/navigation/cancel";
import { Checkbox } from "@material-ui/core";


export default (props) => {
  const [show, setShow] = useState(false);
  const [selectedStartDate, setSelectedStartDate] = useState(
    new Date(props.dateOfEval)
  );
  const [selectedEndDate, setSelectedEndDate] = useState(new Date());
  const [reportData, setReportData] = useState("");
  const [includeProviderActivity, setIncludeProviderActivity] = useState(true);
  const [includePatientActivity, setIncludePatientActivity] = useState(true);

  const formatDate = (dt) => {
    const date = new Date(dt);
    return [
      padTo2Digits(date.getMonth() + 1),
      padTo2Digits(date.getDate()),
      date.getFullYear(),
    ].join("/");
  };

  const padTo2Digits = (num) => {
    return num.toString().padStart(2, "0");
  };

  useEffect(() => {
    setShow(props.showPopup);
  }, [props.showPopup]);

  return (
    <Dialog
      title={"Generate Activity Report For Patient"}
      modal={true}
      open={show}
      onRequestClose={() => {
        setShow(false);
        props.setShowPopup(false);
      }}
      style={{ width: 1200, marginLeft: "20%" }}
    >
      <div
        style={{
          flexDirection: "column",
          display: "flex",
          padding: 10,
          justifyContent: "left",
          justifyItems: "left",
        }}
      >
        <IconButton
          onClick={() => {
            setShow(false);
            props.setShowPopup(false);
          }}
          style={{ position: "absolute", top: 10, right: 10 }}
        >
          <CancelIcon />
        </IconButton>
        <div style={{ display: "flex", flexDirection: "row", flex: 1 }}>
          <div style={{ flexDirection: "column" }}>
            <div style={{ flexDirection: "row" }}>
              <Checkbox defaultChecked color="grey" />
              Include Provider Activity
            </div>
            <div style={{ flexDirection: "row" }}>
              <Checkbox defaultChecked color="grey" />
              Include Patient Activity
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              flex: 1,
              justifyContent: "space-evenly",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                borderWidth: 1,
                borderStyle: "solid",
                borderRadius: 7,
                width: 150,
                padding: 5,
                overflow: "hidden",
              }}
            >
              <span style={{ fontSize: 12, color: colors.accent, padding: 2 }}>
                Start Date
              </span>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <DatePicker
                  defaultDate={selectedStartDate}
                  hideCalendarDate={true}
                  maxDate={new Date()}
                  onChange={(event, date) => {
                    setSelectedStartDate(date);
                  }}
                  style={{
                    fontSize: 14,
                    width: 125,
                  }}
                  containerStyle={{ width: 100 }}
                />
                <CalIcon />
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                borderWidth: 1,
                borderStyle: "solid",
                borderRadius: 7,
                width: 150,
                padding: 5,
                overflow: "hidden",
                marginLef: 5,
              }}
            >
              <span style={{ fontSize: 12, color: colors.accent, padding: 2 }}>
                End Date
              </span>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                }}
              >
                <DatePicker
                  defaultDate={selectedEndDate}
                  hideCalendarDate={true}
                  maxDate={new Date()}
                  onChange={(event, date) => {
                    setSelectedEndDate(date);
                  }}
                  style={{
                    fontSize: 14,
                    width: 125,
                  }}
                  containerStyle={{ width: 100 }}
                />
                <CalIcon />
              </div>
            </div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            margin: 20,
          }}
        >
          <Button
            variant="outlined"
            style={{
              color: colorsV2.primary,
              cursor: "pointer",
              marginRight: 10,
              width: "100%",
            }}
            onClick={() => {
              RTMService()
                .getRtmBillingReport(
                  props.customAppId,
                  props.patientUserId,
                  props.providerUserId,
                  selectedStartDate,
                  selectedEndDate
                )
                .then((response) => {
                  let rptData = "";
                  //Add Header Info About AC Health Before Report Data
                  rptData += " -- FDA Registration -- \n\n";
                  rptData += "Owner/Operator: AdviceCoach ";
                  rptData += "| Proprietary Name: AC Health ";
                  rptData += "| O/O #: 10086320 ";
                  rptData += "| Registration Number: 3024755142 ";
                  rptData += "| Regulation #:  890.5370 ";
                  rptData += "| Product Code - ION ";
                  rptData += "| Demo Class: 1";

                  if (response.customRTMHeader) {
                    rptData += "\n\n" + response.customRTMHeader;

                    //Trabecule X Custom
                    //rptData += "\n\n Repackager/Relabeler: TrabeculeX ";
                    //rptData += "| Device Listing: XD513920 ";
                    //rptData += "| O/O #: 3011181154 ";
                  }

                  if (response) {
                    if (includeProviderActivity) {
                      rptData += "\n\n -- Provider Activity -- \n\n";
                      response.providerActivityList.forEach((e) => {
                        rptData += formatDate(e.dt) + " - " + e.desc + "\n";
                      });
                    }

                    if (includePatientActivity) {
                      rptData += "\n\n -- Patient Activity -- \n\n";
                      response.patientActivityList.forEach((e) => {
                        rptData += formatDate(e.dt) + " - " + e.desc + "\n";
                      });
                    }

                    setReportData(rptData);
                  } else {
                    rptData +=
                      "\n\n -- There was an error generating the report. Please reload the page and try again. -- \n\n";
                    setReportData(rptData);
                  }
                });
              RTMService()
                .markClaimGeneratedFor(props.customAppId, props.userId)
                .then(() => {
                  //No action needed...
                })
                .catch((err) => {
                  alert(err);
                });
            }}
          >
            Generate Report
          </Button>
        </div>
        {reportData && (
          <div
            style={{
              borderStyle: "solid",
              borderWidth: 1,
              borderRadius: 7,
              height: 300,
              overflow: "auto",
              margin: 20,
              fontFamily: "Poppins-Regular",
              fontSize: 12,
              color: colorsV2.primary,
              padding: 15,
            }}
            dangerouslySetInnerHTML={{
              __html: reportData.replaceAll("\n", "<br />"),
            }}
          />
        )}
        {reportData && (
          <div style={{ display: "flex", flexDirection: "row", margin: 20 }}>
            <Button
              variant="outlined"
              style={{
                color: colorsV2.primary,
                cursor: "pointer",
                marginRight: 20,
                width: "100%",
              }}
              onClick={() => {
                if (!navigator.clipboard) {
                  // fallbackCopyTextToClipboard(text);
                  return;
                }
                navigator.clipboard.writeText(reportData).then(
                  () => {
                    alert("Claim Ready To Paste");
                  },
                  (err) => {
                    alert("Unable to copy the claim to your clipboard");
                  }
                );
              }}
            >
              Copy To Clipboard
            </Button>
          </div>
        )}
      </div>
    </Dialog>
  );
};



// WEBPACK FOOTER //
// ./src/components/rtm/GenerateRTMDocumentation.js